export { default } from './debounce';
export * from './debounce';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/debounce/index.js
// module id = 830
// module chunks = 25